<template>
    <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
        <div class="admin-login">
            <img src="../../assets/images/CPV_sistema_positivo_sem_grafismo.png" alt="Logo Sistema CPV" width="120px"
                height="auto" />

            <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
                <b-card no-body class="mt-5 p-3 card-content shadow-sm">
                    <h5>Cadastrar nova senha</h5>
                    <hr>
                    <b-form class="mt-3">
                        <b-form-row>
                            <b-col cols="12">
                                <b-form-group>
                                    <label for="email">E-mail: <span class="text-danger">*</span></label>
                                    <b-input-group>
                                        <b-form-input id="email" type="email" size="sm" v-model="email" required
                                            placeholder="Digite o e-mail cadastrado"></b-form-input>
                                        <b-input-group-append class="append">
                                            <i class="fa-regular fa-envelope"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <i class="text-danger text-error" v-if="$v.email.$error">
                                        <span><i>Informe um endereço de e-mail valido.</i></span>
                                    </i>
                                </b-form-group>
                                <b-form-row>
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <label for="password">Nova senha: <span class="text-danger">*</span></label>
                                            <b-input-group>
                                                <b-form-input id="password" size="sm" :type="typeChk" v-model="password"
                                                    @blur="chk_password" :state="validate_password" debounce="500"
                                                    required placeholder="Digite sua senha"></b-form-input>
                                                <b-input-group-append @click="showPassword"
                                                    class="append show-password">
                                                    <i
                                                        :class="typeChk === 'password' ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"></i>
                                                </b-input-group-append>
                                            </b-input-group>
                                            <i class="text-danger text-error" v-if="$v.password.$error == true">Campo
                                                obrigatório</i>
                                            <i class="text-danger" v-if="!compositionPassword && chk_password">
                                                A senha deve conter:
                                                <ul>
                                                    <li>8 a 20 caracteres,</li>
                                                    <li>Letras maiúsculas e minúsculas,</li>
                                                    <li>Números - (0 - 9),</li>
                                                    <li>Caracteres especiais - (@, #, $, %),</li>
                                                </ul>
                                            </i>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <label for="confirmPassword">Confirmar senha: <span
                                                    class="text-danger">*</span></label>
                                            <b-input-group>
                                                <b-form-input id="confirmPassword" size="sm" :type="typeChk"
                                                    v-model="confirmPassword" :state="validate_password" debounce="500"
                                                    required placeholder="Digite sua senha"></b-form-input>
                                                <b-input-group-append @click="showPassword"
                                                    class="append show-password">
                                                    <i
                                                        :class="typeChk === 'password' ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"></i>
                                                </b-input-group-append>
                                            </b-input-group>
                                            <i class="text-danger text-error" v-if="!$v.confirmPassword.sameAsPassword">
                                                A senhas devem ser iguais.
                                            </i>
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>
                                <hr class="mt-4 mb-0">
                                <div class="mt-4 d-flex align-items-center justify-content-end" v-if="!spin">
                                    <b-button class="float-left p-0 btn-simple mr-3" variant="transparent"
                                        :to="{ name: 'login' }"><i
                                            class="fa-regular fa-arrow-left-to-bracket mr-1"></i>Login</b-button>
                                    <b-button type="submit" @click.stop.prevent="handleSubmit()"
                                        class="float-right btn-sistemacpv" variant="transparent">Enviar</b-button>
                                </div>
                                <div class="mt-4 d-flex aling-items-center justify-content-center" v-if="spin === true">
                                    <b-spinner type="grow" label="Loading..." class="ml-5"></b-spinner>
                                </div>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-card>
            </transition>
        </div>
    </transition>
</template>

<script>
import ApiService from '../../common/api.service';
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators';

import '@/assets/sass/authentication/auth-boxed.scss';
import '@/assets/sass/forms/switches.scss';
import '@/assets/sass/scrollspyNav.scss';

export default {
    name: 'password-recovery-update',
    data() {
        return {
            chk_password: false,
            statusEye: '',
            eyeClose: 'fa-solid fa-eye-slash',
            checked: false,
            type: false,
            spin: false,
            email: '',
            password: '',
            confirmPassword: '',

            typeChk: '',

            dataReset: {
                data: [],
            },
        };
    },

    validations: {
        email: {
            required,
            email,
        },
        password: {
            required,
            minLength: minLength(6),
        },
        confirmPassword: {
            sameAsPassword: sameAs('password'),
        },
    },

    mounted() {
        let btn = document.querySelector('.eye-view-senha');
        btn.addEventListener('click', function () {
            let input = document.querySelector('#password');
            let input2 = document.querySelector('#confirmPassword');

            if (input.getAttribute('type') == 'password' || input2.getAttribute('type') == 'password') {
                input.setAttribute('type', 'text');
                input2.setAttribute('type', 'text');
                document.getElementById('id-eye').setAttribute('class', 'fa-solid fa-eye');
            } else {
                input.setAttribute('type', 'password');
                input2.setAttribute('type', 'password');
                document.getElementById('id-eye').setAttribute('class', 'fa-solid fa-eye-slash');
                document.getElementById('id-eye').setAttribute('class', 'fa-solid fa-eye-slash');
            }
        });

        let regex = /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{8,20}$/;
        console.log(regex.test(this.password));
    },

    created() {
        this.showPassword();
    },

    computed: {
        compositionPassword() {
            let regex = /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{8,20}$/;
            return regex.test(this.password);
        },

        chk_passwords() {
            if (this.chk_password) {
                return true;
            } else {
                return false;
            }
        },
    },

    methods: {
        showPassword() {
            // Alterna o tipo do campo de senha entre 'password' e 'text'
            this.typeChk = this.typeChk === 'password' ? 'text' : 'password';
        },
        handleSubmit(e) {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid && !this.compositionPassword) {
                return;
            }

            this.postDataReset();

            // alert('SUCCESS!! :-)');
        },

        async postDataReset() {

            this.spin = true;
            // garantindo o encerramento da sessao se logado.
            if (this.$store.state.auth.logged) {
                this.$store.dispatch('logout')
            }



            await ApiService.post('/postPasswordUpdate', {
                email: this.email,
                password: this.password,
                token: this.$route.params.token,
            })
                .then((response) => {
                    this.dataReset = response;

                    if (this.dataReset.data.status == 'success') {
                        this.$swal({
                            icon: 'success',
                            title: this.email,
                            text: this.dataReset.data.message,
                            padding: '2em',
                            preConfirm: () => {
                                window.location.href = '/login';
                            },
                        });
                    } else {
                        this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: 'Erro: ' + this.dataReset.data.message,
                            text: this.email,
                            footer: 'Havendo dúvidas entre em contato',
                            padding: '2em',
                            preConfirm: () => {
                                window.location.href = '/login';
                            },
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);

                    this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text: 'Tem algo errado',
                        footer: 'Tente mais tarde',
                        padding: '2em',
                    });
                })
                .finally(() => {
                    this.spin = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.box {
    display: block;
}

.help-block {
    color: red;
}

.input {
    border: solid 1px #c8c7c7;
    border-radius: 0.8rem;
    background: none;
    padding: 1rem;
    font-size: 1rem;
    color: #7b7b7b;
    transition: border 150ms cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 55px;
}

.user-label {
    position: absolute;
    left: 15px;
    color: #7b7b7b;
    pointer-events: none;
    transform: translateY(1rem);
    transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

.input:focus,
input:valid {
    outline: none;
    border: 1.5px solid #1a73e8;
}

select:valid {
    outline: none;
    border: 1.5px solid #1a73e8;
}

.textarea:focus,
textarea:valid {
    outline: none;
    border: 1.5px solid #1a73e8;
}

.input:focus~label,
input:valid~label,
select:valid~label,
textarea:valid~label {
    transform: translateY(-50%) scale(0.8);
    background-color: #fff;
    padding: 0 0.2em;
    color: #2196f3;
}

.centraliza-eye {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.centraliza {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 15px;
}

#verified {
    color: white;
    background: green;
}

.logo-cpv-recovery {
    width: 112%;
    min-height: 200px;
    margin-left: -25px;
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
    margin: -25px 0 15px -25px;
    background-color: #3b1953;
    background-image: url('https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/grafismo_fundo_claro.png') !important;
    background-repeat: no-repeat;
    background-size: 100%;
}

.logo-negativo {
    max-width: 30%;
    float: left;
    margin: 25px 0 0 25px;
}

.sistema-de-ensino {
    color: #e98b24;
    float: left;
    margin: 80px 0 0 -60px;
    text-align: left;
}

.eye-view-senha {
    min-width: 120%;
    min-height: 150px;
    border: 0.09em solid rgba($color: #000000, $alpha: 0.2);
    border-left: none;

    border-top-left-radius: 0%;
    border-bottom-left-radius: 0;
    ;
    border-top-right-radius: 10%;
    border-bottom-right-radius: 10%;
    ;
    cursor: pointer;
    position: absolute;
    float: left;
    margin-left: -38px
}

.eye-back-color {
    background-color: #3b1953;
    color: #fff;
}


section div:last-child {
    background-color: #3a1c53;
    min-width: 94%;
    height: 170px;
    position: absolute;
    z-index: 9999;
    padding: 15px 0 35px 15px;
    border-radius: 15px;
    color: #fff;

}
</style>
